<template>
  <d2-container>
    <el-card class="filter-container" shadow="never">
      <div>
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
        <el-button style="float: right; margin-right: 15px" type="primary" @click="handleSearchList" size="small"> 查询搜索 </el-button>
        <el-button style="float: right; margin-right: 15px" @click="handleResetSearch" size="small"> 重置 </el-button>
      </div>
      <div style="margin-top: 15px">
        <el-form :inline="true" :model="listQuery" size="small" label-width="140px">
          <el-form-item label="主题:">
            <el-input v-model="listQuery.theme" class="input-width" placeholder="主题" clearable></el-input>
          </el-form-item>
          <el-form-item label="标签状态：">
            <el-select v-model="listQuery.status" class="input-width" placeholder="全部" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间：">
            <el-date-picker
              v-model="listQuery.createTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 350px"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="table-container">
      <div class="check-but">
        <div>
          <el-button style="float: right; margin: 5px 10px" type="primary" size="small" @click="handleMoney"> 设置捐款金额 </el-button>
          <el-button style="float: right; margin: 5px 10px" type="success" size="small" @click="handleAdd"> 新增 </el-button>
        </div>
      </div>

      <el-table ref="orderTable" :data="list" style="width: 100%; margin: 10px 0 15px" v-loading="listLoading" border stripe>
        <el-table-column type="index" label="#" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="封面图">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.shrinkUrl" :preview-src-list="[scope.row.shrinkUrl]"> </el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="主题">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              v-if="scope.row.theme"
              width="200"
              trigger="hover"
              :content="scope.row.theme">
              <div slot="reference">{{ scope.row.theme.length>10?scope.row.theme.substring(0, 10) + '...': scope.row.theme }}</div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column align="center" label="捐赠总次数">
          <template slot-scope="scope">
            <div>{{ scope.row.sumUser }}次</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="捐赠总金额">
          <template slot-scope="scope">
            <div>{{ scope.row.sumAmount }}元</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="活动时间">
          <template slot-scope="scope">
            <div><span>开始时间:{{ scope.row.startTime }}</span></div>
                                    至
            <div><span>结束时间:{{ scope.row.endTime }}</span></div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="可用状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ifStatus ==0" type="danger">活动下架不可用</el-tag>
            <el-tag v-if="scope.row.ifStatus ==1" type="danger">已过期时间不可用</el-tag>
            <el-tag v-if="scope.row.ifStatus ==2" type="primary">未到时间不可用</el-tag>
            <el-tag v-if="scope.row.ifStatus ==3" type="success">正常可用</el-tag>
          </template>
        </el-table-column>


        <el-table-column label="标签" width="140" align="center">
        <template slot-scope="scope">
          <p>
            状态：
            <el-switch
              @change="handleStatusChange(scope.$index, scope.row)"
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.status"
            >
            </el-switch>
          </p>
          <p>
            热门：
            <el-switch
              @change="handleIfHotChange(scope.$index, scope.row)"
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.ifHot"
            >
            </el-switch>
          </p>
    
        </template>
      </el-table-column>

        <el-table-column align="center" label="排序">
          <template slot-scope="scope">
            <div>{{ scope.row.sort }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="创建时间">
          <template slot-scope="scope">
            <div><span>{{ scope.row.createTime }}</span></div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <div style="line-height: 45px">
              <el-button size="small" type="text" @click="handleUpdate(scope.row)"> 基础信息 </el-button>
              <el-button size="small" type="text" @click="handleDetail(scope.row)"> 捐赠人详情 </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <template slot="footer">
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :page-sizes="[5, 10, 15, 20, 30, 50]"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>

    <el-dialog title="捐赠属性" :visible.sync="dialogFormVisible" width="50%" :before-close="handleClose">
      <el-card class="filter-container" shadow="never">
        <div>
          <i class="el-icon-setting"></i>
          <span style="margin-left: 5px">基础信息</span>
        </div>
        <div style="margin-top: 15px">
          <el-form :model="form" size="small" label-width="130px" ref="form" :rules="rules">
            <el-form-item label="主题：" prop="theme">
              <el-input v-model="form.theme" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="开始时间：" prop="startTime">
              <el-date-picker style="width:100%"
                v-model="form.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择开始日期时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间：" prop="endTime">
              <el-date-picker style="width:100%"
                v-model="form.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束日期时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="排序：" prop="sort">
              <el-input v-model="form.sort" type="number" autocomplete="off" placeholder="填入数字(倒序)"></el-input>
            </el-form-item>
            <el-form-item label="分享标语：" prop="shareText">
              <el-input v-model="form.shareText" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="标签Tag：">
              <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleTabClose(tag)">
                {{tag}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>

            </el-form-item>


            <el-form-item label="是否热门：" prop="ifHot">
              <el-radio v-model="form.ifHot" :label="0">否</el-radio>
              <el-radio v-model="form.ifHot" :label="1">是</el-radio>
            </el-form-item>

            <el-form-item label="封面图：" prop="shrinkUrl">
              <el-upload
                class="avatar-uploader"
                :action="ossUploadUrl"
                :http-request="uploadFileImg"
                :show-file-list="false"
                :before-upload="beforeUploadImg"
              >
                <img v-if="form.shrinkUrl" :src="form.shrinkUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

          <el-form-item label="轮播图：" prop="hostUrl">
            <el-upload
              :action="ossUploadUrl"
              list-type="picture-card"
              :file-list="selectProductPics"
              multiple
              :http-request="uploadFile"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-success="handleUploadSuccess"
              :on-preview="handlePreview"
              :on-error="handleUploadError"
              :limit="10"
              :on-exceed="handleExceed"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>   


            <div>
              <i class="el-icon-s-order"></i>
              <span style="margin-left: 5px">详细信息</span>
            </div>
            <div style="margin-top: 15px">
              <el-form-item label="详情内容：" prop="content">
                <div style="border: 1px solid #ccc">
                  <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
                  <Editor
                    style="height: 500px; overflow-y: hidden"
                    v-model="form.content"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                    @onChange="onChangeEditor"
                  />
                </div>
              </el-form-item>
              <input ref="rictTextImage" type="file" accept="image/*" name="file" style="display: none" @change="uploadRictTextImage" />
              <input ref="rictTextVideo" type="file" accept="video/*" name="file" style="display: none" @change="uploadRichTextVideo" />
              <div v-if="showProgress" class="progress-wrap">
                <el-progress type="circle" :percentage="progress.rate" class="progress" />
              </div>
            </div>

            <el-form-item label="状态：">
              <el-switch
                style="display: block; line-height: 24px"
                v-model="status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="开启"
                inactive-text="禁用"
              >
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 图片裁剪弹窗（1:1） -->
    <el-dialog title="图片裁剪" :visible.sync="cropperVisible" width="600px" @closed="destroyCropper">
      <div style="max-height: 70vh; overflow: auto;">
        <img ref="cropperImg" :src="cropperImageUrl" alt="crop" style="max-width: 100%; display: block;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCrop">取 消</el-button>
        <el-button type="primary" @click="confirmCrop">确 定</el-button>
      </span>
    </el-dialog>

  <el-dialog
    :visible.sync="drawerSync"
    width="50%"
    :before-close="handleTableClose">
    <div>
      <el-card class="filter-container" shadow="never">
        <div>
          <i class="el-icon-search"></i>
          <span style="margin-left: 5px">筛选搜索</span>
          <el-button style="float: right" type="primary" @click="handleTableSearchList" size="small"> 查询搜索 </el-button>
        </div>
        <div style="margin-top: 30px">
          <el-form :inline="true" :model="tableQuery" size="small" label-width="140px">
            <el-form-item label="操作时间：">
              <el-date-picker
                v-model="tableQuery.createTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 350px"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="用户手机号：">
              <el-input v-model="tableQuery.phone" class="input-width" placeholder="手机号" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <div class="table-container">
        <el-table ref="couponHistoryTable" :data="tableList" style="width: 100%" v-loading="tableLoading" border>
          <el-table-column label="操作时间" width="300" align="center">
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <el-table-column align="center" label="捐赠人头像">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px" :src="scope.row.icon" :preview-src-list="[scope.row.icon]"> </el-image>
            </template>
          </el-table-column>
          <el-table-column label="捐赠人名称" align="center">
            <template slot-scope="scope">{{scope.row.name}}</template>
          </el-table-column>
          <el-table-column label="捐赠金额" align="center">
            <template slot-scope="scope">{{scope.row.amount}}元</template>
          </el-table-column>
          <el-table-column label="捐赠人类型" width="200" align="center">
            <template slot-scope="scope">{{ scope.row.type | filterType }}</template>
          </el-table-column>

          <el-table-column align="center" label="用户留言">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              v-if="scope.row.remark"
              width="200"
              trigger="hover"
              :content="scope.row.remark">
              <div slot="reference">{{ scope.row.remark.length>10?scope.row.remark.substring(0, 10) + '...': scope.row.remark }}</div>
            </el-popover>
            <el-tooltip v-else class="item" effect="dark" content="暂无备注" placement="top">
              <div>暂无备注</div>
            </el-tooltip>
          </template>
        </el-table-column>
        </el-table>
      </div>

      <div class="page-container">
        <el-pagination
          background
          @size-change="handleTableSizeChange"
          @current-change="handleTableCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="tableQuery.pageNum"
          :page-size="tableQuery.pageSize"
          :page-sizes="[5, 10, 15]"
          :total="tableTotal"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>


  <el-dialog title="设置金额" :visible.sync="dialogMoneyFormVisible" width="40%" :before-close="handleMoneyClose">
    
      <el-card class="filter-container" shadow="never">
        <div style="margin-top: 15px">
          <el-form :model="moneyForm" size="small" label-width="130px" ref="moneyForm" :rules="moneyRules">
            <el-form-item label="第一个数值" prop="money1">
              <el-input v-model="moneyForm.money1" class="input-width-80">
                <template slot="append">元</template>
              </el-input>
              <span class="note-margin"></span>
            </el-form-item>
            <el-form-item label="第二个数值" prop="money2">
              <el-input v-model="moneyForm.money2" class="input-width-80">
                <template slot="append">元</template>
              </el-input>
              <span class="note-margin"></span>
            </el-form-item>
            <el-form-item label="第三个数值" prop="money3">
              <el-input v-model="moneyForm.money3" class="input-width-80">
                <template slot="append">元</template>
              </el-input>
              <span class="note-margin"></span>
            </el-form-item>
            <el-form-item label="第四个数值" prop="money4">
              <el-input v-model="moneyForm.money4" class="input-width-80">
                <template slot="append">元</template>
              </el-input>
              <span class="note-margin"></span>
            </el-form-item>
            <el-form-item label="第五个数值" prop="money5">
              <el-input v-model="moneyForm.money5" class="input-width-80">
                <template slot="append">元</template>
              </el-input>
              <span class="note-margin"></span>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleMoneyClose">取 消</el-button>
        <el-button type="primary" @click="handleSaveMoney">确 定</el-button>
      </div>
    </el-dialog>


  </d2-container>
</template>

<script>
import { page , saveOrUpdate ,statusObj , ifHotObj , objHistory , moneyList , saveOrUpdateMoney} from "@/api/workbench/activity/index"
import TinymceEditor from "@/components/tinymce-editor/tinymce-editor"
import richText from "@/mixins/richText"
import wangeditor from "@/mixins/wangeditor"
import axios from "axios"
import Cropper from "cropperjs/dist/cropper.js"
const defaultListQuery = {
  pageNum: 1,
  pageSize: 10,
  status: null,
  activityClassifyId: null,
  theme: null
}
const defaultListForm = {
  id: null,
  theme: "",
  content: "",
  status: null,
  startTime: null,
  endTime:null,
  ifHot:0,
  shrinkUrl:null,
  hostUrl:null,
  shareText:null,
  sort:null,
  tagText:[]
}
const defaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
  createTime: null,
  phone:null,
  id :null
}
export default {
  name: "activityList",
  components: { TinymceEditor },
  props: { value: Object },
  mixins: [richText, wangeditor],
  data() {
    return {
      rules: {
        theme: [{ required: true, message: "请填写主题", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        shrinkUrl: [{ required: true, message: "请上传缩略图", trigger: "blur" }],
        shareText: [{ required: true, message: "请填写分享标语", trigger: "blur" }],
        hostUrl: [{ required: true, message: "请上传轮播图", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
        ifHot: [{ required: true, message: "请选择是否热门", trigger: "blur" }],
        sort: [{ required: true, message: "请填写排序字段", trigger: "blur" }],
      },
      moneyRules: {
        money1: [{ required: true, message: "请填写金额", trigger: "blur" }],
        money2: [{ required: true, message: "请填写金额", trigger: "blur" }],
        money3: [{ required: true, message: "请填写金额", trigger: "blur" }],
        money4: [{ required: true, message: "请填写金额", trigger: "blur" }],
        money5: [{ required: true, message: "请填写金额", trigger: "blur" }],
      },
      listQuery: Object.assign({}, defaultListQuery),
      listLoading: true,
      list: null,
      total: null,
      dialogFormVisible: false,
      dialogMoneyFormVisible: false,
      form: Object.assign({}, defaultListForm),
      moneyForm:{},
      status: true,
      fileData: "",
      imageUrl: "",
      statusOptions: [
        { label: "删除", value: 0 },
        { label: "正常", value: 1 }
      ],
      selectProductPics: [],
      ossUploadUrl: process.env.VUE_APP_API + "/tool/oss/upload",
      dialogVisible: false,
      dialogImageUrl: null,
      drawerSync:false,
      tableQuery: Object.assign({}, defaultTableQuery),
      tableLoading:false,
      tableList:null,
      tableTotal:null,
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      cropperVisible: false,
      cropperImageUrl: '',
      cropperInstance: null,
      pendingAlbumFile: null
    }
  },

  activated() {
    this.getList()
  },
  watch: {
    listQuery: {
      handler(val) {
        Object.keys(val).forEach(key => {
          if (!val[key] && val[key] !== 0) val[key] = undefined
        })
      },
      deep: true
    }

  },
  filters: {
    filterType(type) {
      switch (type) {
        case 1:
          return "个人捐赠"
        case 2:
          return "团队捐赠"
        default:
          return "未知"
      }
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    handleTabClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleDetail(row){
      this.drawerSync = true,
      this.tableQuery.id = row.id
      this.getTableList()
    },
    getTableList() {
      this.tableLoading = true
      const { createTime, ...data } = this.tableQuery
      if (createTime) {
        data.startTime = createTime[0]
        data.endTime = createTime[1]
      }
      objHistory(data).then(response => {
        this.tableLoading = false
        this.tableList = response.rows
        this.tableTotal = response.total
      })
    },
    handleTableSearchList(){
      this.tableQuery.pageNum = 1
      this.getTableList()
    },
    handleTableClose(){
      this.tableQuery=Object.assign({}, defaultTableQuery)
      this.drawerSync = false
    },
    handleStatusChange(index, row) {
      let params = new URLSearchParams()
      params.append("id", row.id)
      params.append("status", row.status)
      statusObj(params).then(response => {
        this.$message.success("修改显示状态成功")
        this.getList()
      })
    },
    handleIfHotChange(index, row) {
      let params = new URLSearchParams()
      params.append("id", row.id)
      params.append("ifHot", row.ifHot)
      ifHotObj(params).then(response => {
        this.$message.success("修改热门状态成功")
        this.getList()
      })
    },
    handleUploadError() {
      this.$message.error("上传失败")
    },
    handleExceed() {
      this.$message.warning("最多只能上传10张图片")
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadSuccess(res) {
      if (this.form.hostUrl) {
         this.form.hostUrl =  this.form.hostUrl + "," + res.data
      } else {
         this.form.hostUrl = res.data
      }
    },
    handleRemove(file, fileList) {
      // 将受控的文件列表与 UI 保持同步，防止“删除后又出现”的问题
      this.selectProductPics = fileList
      // 同步表单字段中的 hostUrl
      const urlArr = fileList.map(item => item.url)
      this.form.hostUrl = urlArr.join(',')
    },
    uploadFile(file) {
      this.fileData = new FormData()
      this.fileData.append("file", file.file)
      axios.post(this.ossUploadUrl, this.fileData, { headers: { "Content-Type": "multipart/form-data" } }).then(res => {
        if (this.form.hostUrl) {
          this.form.hostUrl = this.form.hostUrl + "," + res.data.data
        } else {
          this.form.hostUrl = res.data.data
        }
      })
    },
    // 打开裁剪弹窗并初始化裁剪器
    openCropper(file) {
      this.pendingAlbumFile = file
      const reader = new FileReader()
      reader.onload = () => {
        this.cropperImageUrl = reader.result
        this.cropperVisible = true
        this.$nextTick(() => {
          if (this.cropperInstance) {
            this.cropperInstance.destroy()
          }
          this.cropperInstance = new Cropper(this.$refs.cropperImg, {
            aspectRatio: 1,
            viewMode: 1,
            autoCropArea: 1,
            movable: true,
            zoomable: true,
            scalable: false,
            responsive: true
          })
        })
      }
      reader.readAsDataURL(file)
    },
    // 确认裁剪并上传
    confirmCrop() {
      if (!this.cropperInstance) return
      this.cropperInstance.getCroppedCanvas({ width: 1000, height: 1000 }).toBlob(
        blob => {
          const formData = new FormData()
          const ext = this.pendingAlbumFile && this.pendingAlbumFile.name ? this.pendingAlbumFile.name.split('.').pop() : 'jpg'
          const filename = this.pendingAlbumFile && this.pendingAlbumFile.name ? this.pendingAlbumFile.name : `cropped.${ext}`
          const croppedFile = new File([blob], filename, { type: blob.type || 'image/jpeg' })
          formData.append('file', croppedFile)
          axios
            .post(this.ossUploadUrl, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(res => {
              const url = res.data && res.data.data ? res.data.data : null
              if (url) {
                if (this.form.hostUrl) {
                  this.form.hostUrl = this.form.hostUrl + ',' + url
                } else {
                  this.form.hostUrl = url
                }
                // 避免重复添加，同时更新受控的文件列表
                if (!this.selectProductPics.find(item => item.url === url)) {
                  this.selectProductPics.push({ name: filename, url })
                }
              }
              this.cancelCrop()
            })
            .catch(() => {
              this.$message.error('上传失败')
              this.cancelCrop()
            })
        },
        'image/jpeg',
        0.92
      )
    },
    // 取消裁剪
    cancelCrop() {
      this.cropperVisible = false
      this.pendingAlbumFile = null
    },
    // 销毁裁剪器
    destroyCropper() {
      if (this.cropperInstance) {
        this.cropperInstance.destroy()
        this.cropperInstance = null
      }
      this.cropperImageUrl = ''
    },
    // 商品相册上传前先裁剪（1:1）
    beforeUpload(file) {
      if (this.selectProductPics && this.selectProductPics.length >= 10) {
        this.$message.warning("最多只能上传10张图片")
        return false
      }
      const allowType = ["image/jpeg", "image/png"]
      const allowSize = 1024 * 1024 * 10
      if (!allowType.includes(file.type)) {
        this.$message.error("仅支持 JPG 和 PNG 格式!")
        return false
      }
      if (file.size > allowSize) {
        this.$message.error("大小不能超过 10MB!")
        return false
      }
      // 打开裁剪弹窗并阻止默认上传
      this.openCropper(file)
      return false
    },
    getAlbumnPics() {
      if (this.form.hostUrl && this.form.hostUrl.length > 0) {
        const fileList = this.form.hostUrl.split(",")
        this.selectProductPics = fileList.map(item => {
          return { name: "xxx", url: item }
        })
      } else {
        this.selectProductPics = []
      }
    },
    handleTableSearchList(){
      this.tableQuery.pageNum = 1
      this.getTableList()
    },
    onChangeEditor(e) {
      console.log("e", e)
    },
    handleCommentSearchList(){
      this.commentQuery.pageNum = 1
      this.getCommentList()
    },
    handleTableSizeChange(val) {
      this.tableQuery.pageSize = val
      this.getTableList()
    },
    handleCommentSizeChange(val) {
      this.commentQuery.pageSize = val
      this.getCommentList()
    },
    handleTableCurrentChange(val){
      this.tableQuery.pageNum = val
      this.getTableList()
    },
    handleCommentCurrentChange(val){
      this.commentQuery.pageNum = val
      this.getCommentList()
    },
    beforeUploadImg(file) {
      const allowType = ["image/jpeg", "image/png"]
      const allowSize = 1024 * 1024 * 10
      if (!allowType.includes(file.type)) {
        this.$message.error("仅支持 JPG 和 PNG 格式!")
        return false
      }
      if (file.size > allowSize) {
        this.$message.error("大小不能超过 10MB!")
        return false
      }
      return true
    },
    uploadFileImg(file) {
      this.fileData = new FormData()
      this.fileData.append("file", file.file)
      axios.post(this.ossUploadUrl, this.fileData, { headers: { "Content-Type": "multipart/form-data" } }).then(res => {
        this.form.shrinkUrl = res.data.data
      })
    },
    getUserList() {
      const query = { status: 1, type: 2 }
      list(query).then(response => {
        this.userList = response
      })
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.status = this.status ? 1 : 0
          if(this.dynamicTags.length>0){
            this.form.tagText = this.dynamicTags.join(",")
          }else{
             this.$message.error("请输入标签tag!")
            return
          }
          saveOrUpdate(this.form).then(response => {
            this.$message.success("信息更改成功!")
            this.handleClose()
            this.getList()
          })
        } else {
          return false
        }
      })
    },
    handleSaveMoney(){
      this.$refs["moneyForm"].validate(valid => {
        if (valid) {
          saveOrUpdateMoney(this.moneyForm).then(response => {
            this.$message.success("金额更改成功!")
            this.handleMoneyClose()
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.dialogFormVisible = false
      this.selectProductPics = []
    },
    handleMoneyClose() {
      this.dialogMoneyFormVisible = false
      this.moneyForm={}
    },

    handleAdd() {
      this.status = true
      this.form = Object.assign({}, defaultListForm)
      this.dynamicTags = []
      this.selectProductPics = []
      this.dialogFormVisible = true
    },
    handleMoney(){
      moneyList().then(response => {
       this.dialogMoneyFormVisible = true
       this.moneyForm =  response
      })
    },
    handleUpdate(row) {
      this.dialogFormVisible = true
      this.selectProductPics = []
      this.form = row
      if(this.form.tagText){
        this.dynamicTags = this.form.tagText.split(",")
      }else{
        this.dynamicTags = []
      }
      this.getAlbumnPics()
      this.status = this.form.status == 1 ? true : false
    },
    getList() {
      this.listLoading = true
      const { createTime, ...data } = this.listQuery
      if (createTime) {
        data.startTime = createTime[0]
        data.endTime = createTime[1]
      }
      page(data).then(response => {
        this.listLoading = false
        this.list = response.rows
        this.total = response.total
      })
    },

    handleResetSearch() {
      this.listQuery = Object.assign({}, defaultListQuery)
    },
    handleSearchList() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped>
// 处理副本被其他元素盖住
/deep/ .w-e-full-screen-container {
  z-index: 9999 !important;
}
.drawer {
  /deep/ .el-drawer {
    width: 400px !important;
  }
}
.block {
  margin: 40% 0px;
  /deep/ ul.el-timeline {
    padding: 0px 0px 0px 15px;
  }
}

/deep/ .el-button[data-v-29df88f7] {
     margin-bottom: 0px;
     margin-left: 15px;
}
/deep/ .el-badge__content.is-fixed {
    position: absolute;
    top: 10px;
    right: 10px;
    -webkit-transform: translateY(-50%) translateX(100%);
    transform: translateY(-50%) translateX(100%);
}


.input-width {
  width: 203px;
}
.el-button {
  margin-bottom: 10px;
}
/deep/ .el-dialog__body {
  padding: 0 10px;
}
/deep/ .el-pagination {
    white-space: nowrap;
    padding: 17px 5px;
    color: #303133;
    font-weight: 700;
}
.check-but {
  width: 100%;
  background: #edf2ff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 4px 0px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border: 1px dashed #b0b7c2;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
.upload-class {
  font-size: 67px;
  color: #c0c4cc;
  margin: 40px 0 16px;
  line-height: 50px;
}
/deep/ .el-table {
    margin-top: 13px;

}
 .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .input-width-80 {
  width: 80%;
}
</style>

<style>
</style>
